/**
 * @LastEditors lizijian lizijian@linhuiba.com
 * @Date 2023-05-30 17:05
 * @LastEditTime 2023-06-15 11:06
 * @FilePath /pms-react-pc/src/hooks/useSupplierAndContact.tsx
 * @Description
 */

import { useEffect, useState } from 'react';
import { debounce } from '@lhb/func';
import { post } from '@/common/request';


function useSupplierAndContact(id?: number): any[] {
  const [options, setOptions] = useState<{label: string, value: any}[]>([]);

  const getOptions = async (id: number, keyword?: string, contactId?:number) => {
    if (!id) return;
    const result: any = await post('/tenant/visitRecord/contact/list', { tntPlaceId: id, keyword, contactId }, { proxyApi: '/resserv', needHint: true });
    if (!result) {
      return;
    }
    const options = result.map(item => ({ label: `${item.contactName || ''}-${item.contactPhone || ''}(${item.supplierName || ''})`, value: `${item.supplierId},${item.contactId}` }));
    setOptions(options);
  };

  const onSearch = (value, value2) => {
    const newFn = debounce(getOptions, 500);
    newFn(id, value, value2);
  };


  useEffect(() => {
    getOptions(id!);
  }, [id]);

  return [options, onSearch];
}

export default useSupplierAndContact;
